import { zoomToVis } from "@/animations/zoomToVis.js";
import { canv } from "@/canv/global.js";
import { getViewport } from "@/canvasController/helpers";
import { generateColor } from "@/helpers/generateColor.js";
import { MultiUser } from "./index.ts";
import { eventEmitter } from "@/eventEmitter";

export class multiManager {
    constructor() {
        eventEmitter.dispatch("multi.cursors", {
            disableMultiCursors: this.disableMultiCursors,
        });
    }
    intervalProccessor() {
        canv.intercom.viewMessage(this.getCursorPosition(), getViewport());
        this.timer = setTimeout(this.intervalProccessor.bind(this), 500);
    }

    init() {
        this.timer = setTimeout(this.intervalProccessor.bind(this), 500);
    }

    addMultiUser(data) {
        const isCurrentUser = canv.getInitDataProp("userToken") === data.token;
        const userColor = generateColor(
            isCurrentUser ? data.sessionUID : data.token || data.sessionUID,
        );
        const newMultiUser = new MultiUser(
            data.name,
            data.login,
            data.sessionUID,
            data.token,
            userColor,
        );
        this.multiUsers.push(newMultiUser);
        eventEmitter.dispatch("multi.users.sessions", { users: this.multiUsers });
        canv.appInterface.usersWindow.reFillUsers();

        if (canv.appInterface.timerWindow.status === "running") {
            canv.intercom.fastMessage("timer", {
                action: "run",
                time: canv.appInterface.timerWindow.currentTime,
            });
        }

        canv.applyHighload();
    }

    deleteMultiUser(sessionUID) {
        canv.appInterface.usersWindow.close();

        for (var i = 0; i < this.multiUsers.length; i++) {
            if (this.multiUsers[i].sessionUID === sessionUID) {
                this.multiUsers.splice(i, 1);
                eventEmitter.dispatch("multi.users.sessions", { users: this.multiUsers });
                canv.appInterface.usersWindow.reFillUsers();
                break;
            }
        }

        if (this.viewSubscribeUID === sessionUID) {
            this.resetViewSubscribe();
        }

        canv.applyHighload();

        canv.redraw();
    }

    resetMultiUsers() {
        this.multiUsers = [];
        eventEmitter.dispatch("multi.users.sessions", { users: this.multiUsers });
        canv.appInterface.usersWindow.close();
        this.resetViewSubscribe();
        canv.redraw();
        canv.redraw(1);
    }

    findMultiUser(sessionUID) {
        for (var i = 0; i < this.multiUsers.length; i++) {
            if (this.multiUsers[i].sessionUID === sessionUID) {
                return this.multiUsers[i];
            }
        }

        return null;
    }

    // view data (view + cursor) + select

    applySelectData(data) {
        var multiUser = this.findMultiUser(data["sessionUID"]);
        if (multiUser != null) {
            multiUser.setSelectedGroups(data["selectedGroups"]);
        }
        canv.redraw();
    }

    applyViewData(data) {
        const multiUser = this.findMultiUser(data.sessionUID);
        if (multiUser != null) {
            multiUser.updateVirtualCursor(
                data.cursorPosition.x,
                data.cursorPosition.y,
            );
            multiUser.updateViewData(data.viewPosition);
        } else {
            this.addMultiUser(data);
            const newMultiUser = this.findMultiUser(data.sessionUID);
            if (newMultiUser != null) {
                newMultiUser.updateVirtualCursor(
                    data.cursorPosition.x,
                    data.cursorPosition.y,
                );
                newMultiUser.updateViewData(data.viewPosition);
            }
        }

        this.ApplyViewSubscribe();
    }

    changeVisibilityCursor(isVisible) {
        this.multiUsers.map((item) => {
            item.changeVisibility(isVisible);
        });
    }

    ApplyViewSubscribe() {
        if (this.viewSubscribeUID == "") {
            return;
        }

        const multiUser = this.findMultiUser(this.viewSubscribeUID);

        if (multiUser == null) {
            // Такого быть не должно
            return;
        }

        const screenData = {
            simulatedSelectingStartX: -canv.m[4] / canv.m[0],
            simulatedSelectingStartY: -canv.m[5] / canv.m[3],
            simulatedSelectingWidth: canv.canvas.width / canv.m[0],
            simulatedSelectingHeight: canv.canvas.height / canv.m[3],
        };

        const selectedProps = multiUser.viewData;

        // Центр вьюпорта другого пользователя
        const targetCenterX =
            selectedProps["viewportStartX"] + selectedProps["viewportWidth"] / 2;
        const targetCenterY =
            selectedProps["viewportStartY"] + selectedProps["viewportHeight"] / 2;

        // выбираем меньший коэффициент, чтобы видеть все что видит другой пользователь
        // если выбрать бОльший - будем видеть в том же масштабе, что и другой, но часть контента может обрезаться
        const ratio = Math.min(
            screenData.simulatedSelectingWidth / selectedProps["viewportWidth"],
            screenData.simulatedSelectingHeight / selectedProps["viewportHeight"],
        );

        const goTo = {
            0: canv.m[0] * ratio,
            3: canv.m[3] * ratio,
        };
        goTo["4"] =
            -(targetCenterX - screenData.simulatedSelectingWidth / (2 * ratio)) *
            goTo["0"];
        goTo["5"] =
            -(targetCenterY - screenData.simulatedSelectingHeight / (2 * ratio)) *
            goTo["3"];

        const animation = new zoomToVis(goTo);
        canv.animator.deleteAnimation("zoomTo");
        canv.animator.addAnimation(animation);
        canv.redraw();
    }

    TryViewSubscribe(sessionUID) {
        var shouldFocus = this.viewSubscribeUID !== sessionUID;
        this.resetViewSubscribe();
        if (shouldFocus) {
            var selectedUserLines =
                document.getElementsByClassName("usersWindowItem");
            for (var i = 0; i < selectedUserLines.length; i++) {
                if (selectedUserLines[i].getAttribute("sessionUID") === sessionUID) {
                    selectedUserLines[i].classList.add("usersWindowItemSelectorOn");
                }
            }

            eventEmitter.dispatch("multi.users.trackingSession", {session: sessionUID});
            this.viewSubscribeUID = sessionUID;
            this.ApplyViewSubscribe();
        }
    }

    resetViewSubscribe() {
        this.viewSubscribeUID = "";
        eventEmitter.dispatch("multi.users.trackingSession", {session: null});

        var selectedUserLine = document.getElementsByClassName(
            "usersWindowItemSelectorOn",
        );
        if (selectedUserLine.length != 0) {
            selectedUserLine[0].classList.remove("usersWindowItemSelectorOn");
        }

        canv.animator.deleteAnimation("zoomTo");
    }

    getCursorPosition() {
        var pt = canv.actionManager.getActionPoint();

        var data = {
            x: pt.x,
            y: pt.y,
        };

        return data;
    }

    // draw

    draw() {
        this.drawView();

        if (this.disableMultiCursors || canv.highloadMode) return;
        for (var i = 0; i < this.multiUsers.length; i++) {
            this.multiUsers[i].draw();
        }
    }

    drawView() {
        if (this.viewSubscribeUID == "") return;
        if (this.findMultiUser(this.viewSubscribeUID) == null) return;

        var realHTMLTopHeight = 0;
        var realHTMLPaddingX = 0;
        var realHTMLPaddingY = 0;

        var screenData = {
            simulatedSelectingStartX:
                -canv.m[4] / canv.m[0] + (realHTMLPaddingX / canv.m[0]) * canv.dpr,
            simulatedSelectingStartY:
                -canv.m[5] / canv.m[3] +
                ((realHTMLPaddingY + realHTMLTopHeight) / canv.m[0]) * canv.dpr,
            simulatedSelectingWidth:
                canv.canvas.width / canv.m[0] -
                ((2 * realHTMLPaddingX) / canv.m[0]) * canv.dpr,
            simulatedSelectingHeight:
                canv.canvas.height / canv.m[3] -
                ((2 * realHTMLPaddingY + realHTMLTopHeight) / canv.m[0]) * canv.dpr,
        };

        canv.ctx.strokeStyle =
            this.findMultiUser(this.viewSubscribeUID)?.color || "red";
        canv.ctx.lineWidth = canv.actionManager.getZoomConstant(12);
        canv.ctx.strokeRect(
            screenData.simulatedSelectingStartX,
            screenData.simulatedSelectingStartY,
            screenData.simulatedSelectingWidth,
            screenData.simulatedSelectingHeight,
        );
    }

    setDisableMultiCursors(value) {
        this.disableMultiCursors = value;

        eventEmitter.dispatch("multi.cursors", {
            disableMultiCursors: value,
        });

        canv.redraw();
    }

    /** @type {MultiUser[]} */
    multiUsers = [];
    disableMultiCursors = false;

    viewSubscribeUID = "";
}
